









import Vue from 'vue'
import {Component, Prop, Watch} from "vue-property-decorator";

@Component
export default class Notes extends Vue{
  @Prop(String) readonly defaultNote!: string;
  @Prop({required: true}) fieldName!: string;
  @Prop() placeholder?: string;

  note = this.defaultNote;

  @Watch('defaultNote')
  onDefaultNoteChange(){
    this.note = this.defaultNote;
  }
  @Watch('note')
  onNoteChanged(newValue: string){
    this.$emit('update:defaultNote', newValue)
  }
}
